import React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';

import ListItem from 'rebook/apps/base/components/ListItem';
import TagLabel from 'rebook/apps/base/components/TagLabel';
import { Rightholder } from 'rebook/apps/catalog/models';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const BookRightholder = ({ book, user, extraClassName, maxTagsSize }) => {
  const rightholderTag = (rightholder) => {
    if (!rightholder) {
      return null;
    }

    const theRightholder = new Rightholder(rightholder);

    return (
      <div className={styles.rightholderTag}>
        <ListItem
          extraClassName={styles.listItem}
          key={rightholder.id}
          link={theRightholder.getLink()}>
          <TagLabel
            withoutBorder
            maxWidth={maxTagsSize}
            name={rightholder.name}
            extraClassName={styles.rightholderName} />
        </ListItem>
        <span className={styles.rightholderCounter}>
          {rightholder.counters.books}
          &nbsp;{pluralize(rightholder.counters.books, 'книга', 'книги', 'книг')}
        </span>
      </div>
    );
  };


  const isForAnonymous = !user;
  const isUnavailable = !book.available && !book.available_for_user;
  const isAudioBook = book.type === 'audio';
  const rightholder = get(book, 'rightholder', null);

  return (
    <div className={
      classNames(styles.genresThemes, extraClassName, { isUnavailable }, { isForAnonymous }, { isAudioBook })}>
      {rightholder && (
        <div className={classNames(styles.genresThemesSection, 'jest-rightholder-tag-link')}>
          <h3>Издатель</h3>
          <ul className={styles.itemList}>
            {rightholderTag(rightholder)}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BookRightholder;
